import { contests } from '@/config/api'
import ApiService from '@/services/api.service'

const state = () => ({
    contestsList: [],
    topics: [],
    dates: [],
    specialtiesList: [],
    contestsTotal: 0,
    content: null,
    tasksTotal: 0,
    userTasksTotal: 0,
    contestsLimitOnPage: 10,
    tasksLimitOnPage: 10,
    tasks: [],
    userTasks: [],
    errors: []

})

const getters = {
    getContestsList: state => state.contestsList,
    getContest: state => state.content,
    getTasks: state => state.tasks,
    getDates: state => state.dates,
    getUserTasks: state => state.userTasks,
    getContestsTotal: state => state.contestsTotal,
    getTasksTotal: state => state.tasksTotal,
    getUserTasksTotal: state => state.userTasksTotal,
    getContestsLimitOnPage: state => state.contestsLimitOnPage,
    getTasksLimitOnPage: state => state.tasksLimitOnPage,
    getErrors: state => state.errors
}

const actions = {

    async fetchContestsList ({ commit, getters }, params) {
        const formattedParams = {
            ...params,
            limit: params.limit || getters.getContestsLimitOnPage,
            offset: (getters.getContestsLimitOnPage * (parseInt(params.page) || 1)) - getters.getContestsLimitOnPage
        }
        try {
            // commit('START_LOAD_DNT_LIST')
            const response = await ApiService.get(contests.list, {
                params: {
                    language: 'en',
                    ...formattedParams
                },
                useCache: true
            })

            commit('SET_CONTESTS_LIST', {
                payload: response.data.data,
                headers: response.headers
            })
        } catch (err) {
            commit('SET_CONTESTS_LIST', {
                payload: [],
                headers: {}
            })
            console.log(err)
            throw err
        }
    },

    async fetchContest ({ commit,  }, alias) {

        try {
            commit('START_LOAD_CONTEST')
            const response = await ApiService.get(contests.content(alias), {

            })

            commit('SET_CONTEST_CONTENT', {
                payload: response.data.data
            })
        } catch (err) {
            commit('SET_CONTEST_CONTENT', {
                payload: []
            })
            console.log(err)
            throw err
        }
    },




    async saveContest ({commit}, data) {
        try {
            const response = await ApiService.post(contests.save, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async deleteContest ({commit}, contestId) {
        try {
            const response = await ApiService.post(contests.delete, {contest_id: contestId})
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async participateInContest ({commit}, data) {
        try {
            const response = await ApiService.post(contests.participate, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },


    async closeContest ({commit}, data) {
        try {
            const response = await ApiService.post(contests.close, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async clearErrors ({commit}) {
        commit('CLEAR_ERRORS')
    }
}

const mutations = {
    CLEAR_ERRORS (state) {
        state.errors = []
    },

    ADD_ERROR (state, payload) {
        state.errors.push(payload)
    },

    START_LOAD_CONTEST(state) {
        state.content = null
    },

    SET_CONTESTS_LIST (state, { payload, headers }) {
        state.contestsList = payload
        state.contestsTotal = parseInt(headers['x-items-total'])
    },

    SET_TASKS_LIST (state, { payload, headers }) {
        state.tasks = payload
        state.tasksTotal = parseInt(headers['x-items-total'])
    },

    SET_CONTEST_CONTENT (state, { payload }) {
        state.content = payload
    },

    SET_CONTEST_DATES (state, { payload }) {
        state.dates = payload
    },

    SET_USER_TASKS_LIST (state, { payload, headers }) {
        state.userTasks = payload
        state.userTasksTotal = parseInt(headers['x-items-total'])
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
